import React from 'react'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import SolidCheckCircleIcon from 'LuxKit/Icons/solid/SolidCheckCircleIcon'

export const showSuccessSnackbar = (message: string) => {
  showSnackbar(message, 'success', { icon: <SolidCheckCircleIcon /> })
}

export const showErrorSnackbar = (message: string) => {
  showSnackbar(message, 'critical')
}
